import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { BoardQnaList } from './BoardQnaList';
import { BoardQnaView } from './BoardQnaView';
import { BoardQnaModify } from './BoardQnaModify';
import { PrivateRoute } from '../../components/PrivateRoute';
import { BoardQnaForm } from './BoardQnaForm';


export const BoardQnaPage = ()=>{
    return (
        <div className="subpage">
            <div id="contents" className="bbs qna">
                <div className="sub_header">
                    <div className="inner">
                        <div className="title_wrap">
                        </div>
                    </div>
                </div>
                <div className="sub_header_deco"></div>
                <Routes>
                    <Route path="/" element={ <BoardQnaList/> } /> 
                    <Route path="/create" element={ <BoardQnaForm/> } /> 
                    <Route path="/view/:id" element={ <PrivateRoute><BoardQnaView/></PrivateRoute> } /> 
                    <Route path="/edit/:id" element={ <PrivateRoute><BoardQnaModify/></PrivateRoute> } /> 
                </Routes>
            </div>
        </div>
    );
};